<template>
  <b-col md="7" lg="8">
    <!-- Product template -->
    <ProductRow v-for="item in cartItems" :key="item.key" :prod="item" />
  </b-col>
</template>

<script>
import ProductRow from "./ProductRow";
import { mapGetters } from "vuex";

export default {
  name: "OrderProducts",
  components: {
    ProductRow
  },
  computed: {
    ...mapGetters({
      cartItems: "getCartItems",
      cartItemsCount: "getCartItemsCount"
    })
  }
};
</script>

<style>
</style>